<template>
	<b-modal
	        cancel-title="Annulla"
	        ok-title="Salva"
	        id="modal_send_auto"
	        title="Invii automatici"
	        scrollable
	        centered
	        @ok="setAutoSend"
	      >
	        <div class="form-group has-warning">
	          <label class="control-label">Inserire gli indirizzi a cui inviare il report</label>
	          <textarea class="form-control" v-model.trim="sendAutoEmails"></textarea>
	          <span class="has-warning mt-2">Inserire un indirizzo per riga</span>
	        </div>
	        <div class="form-group">
	          <label class="control-label">Inserire il giorno del mese (1-28) in cui inviare il report</label>
	            <input type="number" class="form-control" v-model="sendAutoDayOfMonth" />
	        </div>
			<b-alert :show="hasErrors" variant="warning">Compilare tutti i campi</b-alert>
	      </b-modal>
</template>
<script>
export default {
	name: "SendAutoModal",
	props: {
		id: Number,
	},
	data() {
		return {
			sendAutoDayOfMonth: 1,
			sendAutoEmails: '',
			hasErrors: false
		}		
	},
	methods: {
		setAutoSend(bvModalEvent) {
			bvModalEvent.preventDefault()

			const emails = this.sendAutoEmails.split('\n').filter(item => item.length)

			this.hasErrors = false
			if (!this.sendAutoDayOfMonth && emails.length > 0) {
				this.hasErrors = true
				return
			}

			
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Reports/SendAutoModal/SendAutoModal.vue